const PRODUCTION = 'prod';
const SANDBOX = 'sbx';
const VALID_ENVIRONMENTS = [PRODUCTION, SANDBOX];
const ENVIRONMENT_LOCAL_STORAGE_KEY = 'selectedEnvironment';

module.exports = {
  PRODUCTION,
  SANDBOX,
  VALID_ENVIRONMENTS,
  ENVIRONMENT_LOCAL_STORAGE_KEY,
};
